import { render } from "./AbsenceDeduction.vue?vue&type=template&id=0be8ab21&scoped=true"
import script from "./AbsenceDeduction.vue?vue&type=script&lang=js"
export * from "./AbsenceDeduction.vue?vue&type=script&lang=js"

import "./AbsenceDeduction.vue?vue&type=style&index=0&id=0be8ab21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be8ab21"]])

export default __exports__